var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"d-flex li-row position-absolute rounded-3 justify-content-center align-items-center",attrs:{"target":"_blank","href":"https://www.linkedin.com/company/senscreed/"}},[_c('i',{staticClass:"li-icon"})])
}]

export { render, staticRenderFns }